"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var DirectoryTree = antd_1.Tree.DirectoryTree;
var TreeNode = antd_1.Tree.TreeNode;
var BrandsCtxTreeList = /** @class */ (function (_super) {
    __extends(BrandsCtxTreeList, _super);
    function BrandsCtxTreeList(props) {
        var _this = _super.call(this, props) || this;
        _this.root_prefix = "r-";
        _this.dir_prefix = "d-";
        return _this;
    }
    BrandsCtxTreeList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                brands: data.brands
            }, function () {
                _this.applyProps(_this.props);
            });
        });
        this.setState({
            brands: [],
            selKey: [],
            expKeys: []
        }, function () {
            _this.props.data.LoadData();
        });
        this.applyProps(this.props);
    };
    BrandsCtxTreeList.prototype.componentWillReceiveProps = function (nextProps) {
        this.applyProps(nextProps);
    };
    BrandsCtxTreeList.prototype.applyProps = function (props) {
        if (props.forceSelectDirMode === "dir") {
            this.setState({
                selKey: ["" + this.dir_prefix + this.mkDirKey(props.selectedBrandId, props.selectedDirName)]
            });
        }
        if (props.forceSelectDirMode === "root") {
            this.setState({
                selKey: ["" + this.root_prefix + this.mkBrandKey(props.selectedBrandId)]
            });
        }
        var _keys = [];
        for (var i = 0; i < props.data.DATA.brands.length; i++) {
            var _k = "" + this.root_prefix + this.mkBrandKey(props.data.DATA.brands[i].key);
            _keys.push(_k);
        }
        this.setState({ expKeys: _keys });
    };
    BrandsCtxTreeList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandsCtxTreeList.prototype.mkDirKey = function (brand, DirName) {
        var _ret = {
            brandId: brand,
            dirName: DirName
        };
        return JSON.stringify(_ret);
    };
    BrandsCtxTreeList.prototype.onSelect = function (keys, event) {
        var _this = this;
        this.setState({ selKey: keys }, function () {
            if (keys[0].startsWith(_this.root_prefix)) {
                var rkey = keys[0].slice(_this.root_prefix.length);
                var irkey = JSON.parse(rkey);
                if (_this.props.onSelectRootNode) {
                    _this.props.onSelectRootNode(irkey.brandId);
                }
            }
            if (keys[0].startsWith(_this.dir_prefix)) {
                var dkey = keys[0].slice(_this.root_prefix.length);
                var idkey = JSON.parse(dkey);
                if (_this.props.onSelectDirNode) {
                    _this.props.onSelectDirNode(idkey.brandId, idkey.dirName);
                }
            }
        });
    };
    ;
    BrandsCtxTreeList.prototype.mkBrandKey = function (brand) {
        var _ret = {
            brandId: brand
        };
        return JSON.stringify(_ret);
    };
    BrandsCtxTreeList.prototype.getBrandsNodes = function () {
        var _ret = [];
        for (var i = 0; i < this.props.data.DATA.brands.length; i++) {
            var _k = "" + this.root_prefix + this.mkBrandKey(this.props.data.DATA.brands[i].key);
            _ret.push(React.createElement(TreeNode, { icon: React.createElement(antd_1.Icon, { type: "cloud" }), title: "" + this.props.data.DATA.brands[i].title, key: "" + _k }, this.getBrandDirectoryNodes(this.props.data.DATA.brands[i])));
        }
        return _ret;
    };
    BrandsCtxTreeList.prototype.getBrandDirectoryNodes = function (brand) {
        var _ret = [];
        for (var i = 0; i < brand.directories.length; i++) {
            _ret.push(React.createElement(TreeNode, { icon: React.createElement(antd_1.Icon, { type: "folder" }), title: "" + brand.directories[i].dirName, key: "" + this.dir_prefix + this.mkDirKey(brand.key, brand.directories[i].dirName), isLeaf: true }));
        }
        return _ret;
    };
    BrandsCtxTreeList.prototype.getRenderObject = function () {
        return (React.createElement("div", { style: {
                width: "300px",
                borderColor: "black",
                borderStyle: "solid",
                borderWidth: "1px",
                overflowY: "scroll",
                overflowX: "hidden"
            } },
            React.createElement(DirectoryTree, { multiple: false, expandedKeys: this.state.expKeys, selectedKeys: this.state.selKey, onSelect: this.onSelect.bind(this), expandAction: false }, this.getBrandsNodes())));
    };
    BrandsCtxTreeList.prototype.render = function () {
        return (this.getRenderObject());
    };
    return BrandsCtxTreeList;
}(React.Component));
exports.default = BrandsCtxTreeList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_images/ui/component/controls/BrandsCtxTreeList.tsx
// module id = 2365
// module chunks = 0